function parseBoolean(value) {
  return value === 'false' || value === '0' || value === 'no' ? false : !!value;
}

function setValue(substitute, defaultValue) {
  if (typeof substitute === 'string' && substitute.startsWith('__') && substitute.endsWith('__')) {
    // still replacement tag, return default
    return defaultValue;
  }

  if (typeof defaultValue === 'number') {
    // Numbers
    return +substitute;
  }

  if (typeof defaultValue === 'boolean') {
    // Booleans
    return parseBoolean(substitute);
  }

  // string
  return substitute;
}

// Because we want to be able to use https://staging.adminpulse.be & https://app.adminpulse.be
// Without having to rebuild our bundle, use the current window location URL as
// API and app endpoint. This should work because the main API is hosted on the same endpoint as our
// app which will be either staging.adminpulse.be or app.adminpulse.be
const currentUrl = window.location.origin;

const buildType = process.env.NODE_ENV;
const environment = setValue('__ENVIRONMENT__', 'local');

const domainMapping = {
  local: 'dev',
  development: 'dev',
  dev: 'dev',
  acceptance: 'acc',
  acc: 'acc',
  production: 'app',
  app: 'app',
  prd: 'app',
};
const subdomain = domainMapping[environment.toLowerCase()] || 'app';

const appUrls = {
  identity: setValue('__IDENTITY_API__', process.env.REACT_APP_IDENTITY_API),
  notifications: setValue('__NOTIFICATION_API__', process.env.REACT_APP_NOTIFICATION_API),
  tasks: setValue('__TASK_API__', process.env.REACT_APP_TASK_API),
  documents: setValue('__DOCUMENT_API__', process.env.REACT_APP_DOCUMENT_API),
  documentsConverter: setValue(
    '__DOCUMENTS_CONVERTER_API__',
    process.env.REACT_APP_DOCUMENTS_CONVERTER_API,
  ),
  documentSigning: setValue('__DOCUMENT_SIGNING_API__', process.env.REACT_APP_DOCUMENT_SIGNING_API),
  jobs: setValue('__JOBS_API__', process.env.REACT_APP_JOBS_API),
  connect: setValue('__CONNECT_WEB__', process.env.REACT_APP_CONNECT_WEB),
  connectApi: setValue('__CONNECT_API__', process.env.REACT_APP_CONNECT_API),
  connectRelationsApi: setValue(
    '__CONNECT_RELATIONS_API__',
    process.env.REACT_APP_CONNECT_RELATIONS_API,
  ),
  signalr: setValue('__SIGNALR_API__', process.env.REACT_APP_SIGNALR_API),
  reporting: setValue('__REPORTING_API__', process.env.REACT_APP_REPORTING_API),
  api: setValue('__ADMIN_PULSE_API__', process.env.REACT_APP_MAIN_API),
  audit: setValue('__AUDIT_API__', process.env.REACT_APP_AUDIT_API),
  interactions: setValue('__INTERACTIONS_API__', process.env.REACT_APP_INTERACTIONS_API),
  app: currentUrl,
  storage: `https://${subdomain}.adminpulse.be`, // Frontend storage
};

if (currentUrl.endsWith('.nl')) {
  for (const key in appUrls) {
    if (typeof appUrls[key] !== 'string') continue;

    appUrls[key] = appUrls[key].replace('.be', '.nl');
  }
}

const config = {
  environment,
  userflowKey: setValue('__userflowKey___', process.env.REACT_APP_USERFLOW_KEY),
  appInsightsKey: setValue('__appInsightsKey__', process.env.REACT_APP_APP_INSIGHTS_KEY),
  buildVersion: setValue('2026.131_20260706.1', `local_${new Date().getTime()}`),

  logLevel: process.env.REACT_APP_LOG_LEVEL || 'debug',
  buildType,
  version: process.env.BUILD_VERSION,
  googleApiKey: setValue('__GOOGLE_API_KEY__', process.env.REACT_APP_GOOGLE_API_KEY),
  appUrls,
  recaptchaKey: '6LeLPzEpAAAAAKr4K_NJN01df8c3QnOkKWR8sd0s', // this is not a secret
  auth: {
    authority: appUrls.identity,
    client_id: 'js',
    redirect_uri: `${appUrls.app}/Callback/Login`,
    response_type: 'id_token token',
    scope: 'openid profile api1',
    silent_redirect_uri: `${appUrls.app}/Callback/SilentLogin`,
    automaticSilentRenew: true,
    post_logout_redirect_uri: appUrls.app,
  },

  features: {
    // names should be lowercase
  },
};

export default config;
